/*
  Meting keuzehulp en filters (22-10-2026).
  Elke gebeurtenis gaat naar:
  - Microsoft Clarity: als "event" (direct te tellen in het Clarity-dashboard) en als sessielabel
  - Google Tag Manager: als dataLayer-event (keuzehulp_antwoord, filter_klik, ...)
  - Shopify: via Shopify.analytics.publish (voor een eventuele eigen pixel)
  Geen persoonsgegevens, alleen de gekozen antwoorden en filters.
*/
(function () {
  if (window.MWKMeting) return;

  function slug(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/€/g, 'eur').replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 40);
  }
  function tekst(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }

  function track(naam, data, clarityNaam) {
    data = data || {};
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: naam }, data)); } catch (e) {}
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', naam);
        if (clarityNaam) window.clarity('event', clarityNaam);
      }
    } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(naam, data); } catch (e) {}
  }
  function label(naam, waarde) {
    try { if (typeof window.clarity === 'function') window.clarity('set', naam, String(waarde)); } catch (e) {}
  }
  // Klikken die de pagina herladen (filters) eerst bewaren en op de volgende pagina versturen
  var QK = 'mwk-meting-wachtrij';
  function later(naam, data, clarityNaam) {
    try { var q = JSON.parse(sessionStorage.getItem(QK) || '[]'); q.push([naam, data, clarityNaam]); sessionStorage.setItem(QK, JSON.stringify(q.slice(-20))); }
    catch (e) { track(naam, data, clarityNaam); }
  }
  function verstuurWachtrij() {
    try { var q = JSON.parse(sessionStorage.getItem(QK) || '[]'); sessionStorage.removeItem(QK); q.forEach(function (x) { track(x[0], x[1], x[2]); }); } catch (e) {}
  }
  window.MWKMeting = { track: track, slug: slug };
  // Clarity laadt soms later dan dit script: wachtrij versturen zodra de pagina klaar is
  if (document.readyState === 'complete') setTimeout(verstuurWachtrij, 500); else window.addEventListener('load', function () { setTimeout(verstuurWachtrij, 500); });

  var collectie = (location.pathname.match(/\/collections\/([^/?#]+)/) || [])[1] || '';
  var khGestart = false;

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // 1. Filterklik op een collectiepagina
    var f = t.closest('a.collection-filters__filter-link');
    if (f) {
      var groep = tekst((f.closest('[data-filter-group]') || document).querySelector('.collection-filters__filter-title'));
      var waarde = tekst(f.querySelector('.collection-filters__filter-list-item-text') || f).replace(/\s*\(\d+\)\s*$/, '');
      var aan = !f.hasAttribute('data-filter-active');
      later('filter_klik', { filter_groep: groep, filter_waarde: waarde, filter_actie: aan ? 'aan' : 'uit', collectie: collectie },
        aan ? 'filter_' + slug(groep) + '_' + slug(waarde) : null);
      return;
    }

    // 2. Knop of tegel naar de keuzehulp vanaf een collectie
    var link = t.closest('a.kh-button, a.kh-tile');
    if (link) {
      var soort = link.classList.contains('kh-tile') ? 'tegel' : 'knop';
      later('keuzehulp_link_klik', { link_type: soort, collectie: collectie }, 'kh_link_' + soort);
      return;
    }

    // 3. Keuzehulp zelf
    if (!t.closest('#kh')) return;
    var opt = t.closest('.kh-opt');
    if (opt && !opt.disabled) {
      var vraag = opt.getAttribute('data-q'), antw = opt.getAttribute('data-v');
      var aanK = opt.getAttribute('aria-pressed') !== 'true';
      var lbl = tekst(opt.querySelector('.l') || opt);
      if (!khGestart) { khGestart = true; track('keuzehulp_gestart', {}, null); }
      track('keuzehulp_antwoord', { vraag: vraag, antwoord: antw, antwoord_label: lbl, actie: aanK ? 'aan' : 'uit' },
        aanK ? 'kh_' + slug(vraag) + '_' + slug(lbl) : null);
      if (aanK) label('kh_' + slug(vraag), lbl);
      // Aantal passende modellen na dit antwoord (wordt direct na de klik bijgewerkt)
      setTimeout(function () {
        var sub = tekst(document.getElementById('khSub'));
        var n = parseInt(sub, 10);
        track('keuzehulp_resultaat', { vraag: vraag, aantal_modellen: isNaN(n) ? 0 : n }, isNaN(n) || n === 0 ? 'kh_geen_resultaat' : null);
      }, 0);
      return;
    }
    var prod = t.closest('.kh-item a, .kh-list a');
    if (prod) {
      var item = prod.closest('.kh-item');
      var positie = 'lijst';
      if (item) { var alle = Array.prototype.slice.call(document.querySelectorAll('#kh .kh-item')); positie = 'top' + (alle.indexOf(item) + 1); }
      var titel = tekst(prod.closest('.kh-item, li').querySelector('.productitem--title, .t'));
      track('keuzehulp_product_klik', { positie: positie, product: titel }, 'kh_product_' + positie);
      return;
    }
    if (t.closest('#khChipX')) { track('keuzehulp_alle_merken', {}, 'kh_alle_merken'); return; }
    if (t.closest('#khReset')) { track('keuzehulp_opnieuw', {}, 'kh_opnieuw'); return; }
    if (t.closest('#khMeer')) { track('keuzehulp_meer', {}, 'kh_toon_meer'); return; }
    if (t.closest('#khRuim')) { track('keuzehulp_zonder_budget', {}, 'kh_zonder_budget'); return; }
  }, true);

  // Prijsfilter (van/tot) en sorteren op de collectiepagina
  document.addEventListener('change', function (e) {
    var i = e.target;
    if (!i || !i.matches) return;
    if (i.matches('input[data-filter-range]')) {
      var welke = /gte/.test(i.name) ? 'vanaf' : 'tot';
      later('filter_klik', { filter_groep: 'Prijs', filter_waarde: welke + ' ' + i.value, filter_actie: 'aan', collectie: collectie }, 'filter_prijs_' + welke);
    } else if (i.matches('select[data-productgrid-trigger-sort], select#product_grid_sort')) {
      later('sorteren', { sorteren: i.value, collectie: collectie }, 'sorteren_' + slug(i.value));
    }
  }, true);

  // Bezoek aan de keuzehulp-pagina, met de herkomst (collectie of merk)
  if (document.getElementById('kh')) {
    var p = new URLSearchParams(location.search);
    track('keuzehulp_bezoek', { vanaf_plaats: p.get('plaats') || '', vanaf_merk: p.get('merk') || '' }, p.get('merk') || p.get('plaats') ? 'kh_bezoek_vanaf_collectie' : 'kh_bezoek_direct');
  }
})();
